class CareMegaMenu extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
    const options = { signal: this.controller.signal };
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !this.closest('details')?.open) return;
      clearTimeout(this.hoverTimer);
      const disclosure = this.closest('mega-menu-disclosure');
      disclosure.close();
      disclosure.summaryElement.focus();
    }, options);
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index), options);
      tab.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches) return;
        clearTimeout(this.hoverTimer);
        this.hoverTimer = setTimeout(() => {
          // 不隐藏仍持有键盘焦点的商品链接。
          if (!this.panels.some(panel => panel.contains(document.activeElement))) this.select(index);
        }, 100);
      }, options);
      tab.addEventListener('pointerleave', () => clearTimeout(this.hoverTimer), options);
      tab.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.panels[index].querySelector('a')?.focus();
          return;
        } else return;
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      }, options);
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
    clearTimeout(this.hoverTimer);
  }

  select(index) {
    if (this.tabs[index].getAttribute('aria-selected') === 'true') return;
    this.tabs.forEach((tab, current) => {
      const selected = current === index;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      this.panels[current].hidden = !selected;
    });
    this.panels[index].querySelector('.care-menu__scroll').scrollTop = 0;
  }
}

if (!customElements.get('care-mega-menu')) customElements.define('care-mega-menu', CareMegaMenu);
